module.exports = __webpack_public_path__ + "img/CasinoChangeName_2bcf2259abb7645eda715df35350cfbe_20211014010020.6a454ebf.jpg";